import i18n from '@dms/i18n';

/**
 * Allowed JWT lifetime presets for a Service Account, in seconds.
 *
 * The backend accepts any integer in [1, 3600]; the product design exposes a
 * fixed set of presets. `maxTokenLifetime` is immutable after creation.
 */
export const MAX_TOKEN_LIFETIME_OPTIONS = [
  {value: '3600', label: i18n.t('entity.serviceAccount.labels.maxTokenLifetimeOption3600')},
  {value: '1800', label: i18n.t('entity.serviceAccount.labels.maxTokenLifetimeOption1800')},
  {value: '900', label: i18n.t('entity.serviceAccount.labels.maxTokenLifetimeOption900')},
  {value: '300', label: i18n.t('entity.serviceAccount.labels.maxTokenLifetimeOption300')},
];

export const DEFAULT_MAX_TOKEN_LIFETIME = '3600';
